module.exports = __webpack_public_path__ + "assets/img/031.738f0f7d.jpg";